module.exports = __webpack_public_path__ + "img/download_DOC.6b2986ad.svg";